export const REACTIVE_REPOSITORIES_MIGRATION_SQL = `
CREATE TABLE repository_events (
  sequence INTEGER PRIMARY KEY AUTOINCREMENT,
  event_type TEXT NOT NULL,
  entity_id TEXT NOT NULL,
  occurred_at TEXT NOT NULL,
  payload_json TEXT NOT NULL,
  delivery_attempts INTEGER NOT NULL DEFAULT 0 CHECK(delivery_attempts >= 0),
  delivered_at TEXT
) STRICT;

CREATE INDEX idx_repository_events_type_sequence
  ON repository_events(event_type, sequence);

CREATE INDEX idx_repository_events_delivery_sequence
  ON repository_events(delivered_at, sequence);

CREATE TABLE client_settings (
  key TEXT PRIMARY KEY NOT NULL,
  value_json TEXT NOT NULL,
  updated_at TEXT NOT NULL
) STRICT;
`;
//# sourceMappingURL=004_reactive_repositories.sql.js.map